/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private promptEvent: any;
  private isInstallableSubject = new BehaviorSubject<boolean>(false);

  isInstallable$ = this.isInstallableSubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.promptEvent = event;
        this.isInstallableSubject.next(true);
      });
    }
  }

  public promptInstall() {
    if (this.promptEvent) {
      this.promptEvent.prompt();
      this.promptEvent.userChoice.then((choiceResult: { outcome: string }) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.promptEvent = null;
        this.isInstallableSubject.next(false);
      });
    }
  }

  public isRunningStandalone(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isIos = /iPhone|iPad|iPod/.test(navigator.userAgent) ||
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // Check if running in standalone mode (general) or fullscreen (iOS specific)
    return isStandalone || (isIos && (window.navigator as any).standalone);
  }
}
